import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { withRouter, NavLink } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import routes from "Configs/routes";

const useStyles = createUseStyles((theme) => ({
	root: {
		height: "40px",
		userSelect: "none",
		fontSize: "14px",
		lineHeight: "1",
		padding: "0 16px",
		margin: "0px 5px 5px 0",
		borderRadius: "10px",
		border: "solid 1px " + theme.palette.colors.disabled,
		fontFamily: "MuseoSansCyrl-700",
		letterSpacing: "2.3px",
		color: theme.palette.colors.purplishBlue,
		textTransform: "uppercase",
		cursor: "pointer",
		display: "inline-flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: theme.palette.colors.white,
		textAlign: "center",
		"&:hover": {
			color: theme.palette.colors.purplishBlue,
		},
	},
	rootOperator: {
		margin: "5px 5px 0px 0",
	},
	isStub: {
		height: "40px",
		width: "65px",
		userSelect: "none",
		lineHeight: "1",
		padding: "0 16px",
		margin: "0px 5px 5px 0",
		borderRadius: "10px",
		border: "solid 1px " + theme.palette.colors.disabled,
		letterSpacing: "2.3px",
		display: "inline-flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: theme.palette.colors.disabled,
	},
	active: {
		backgroundColor: theme.palette.colors.purplishBlue,
		color: theme.palette.colors.white,
		border: `1px solid ${theme.palette.colors.purplishBlue}`,
		"&:hover": {
			color: theme.palette.colors.white,
		},
	},
	unikalnye: {
		color: theme.palette.colors.orange,
		"&:hover": {
			color: theme.palette.colors.orange,
		},
	},
	buttonProviderReviews: {
		margin: "0px 10px 0 0",
		fontSize: "16px",
		lineHeight: "0.6",
	},
	linkProviderReviews: {},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		rootOperator: {
			fontSize: "12px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			height: "25px",
			fontSize: "12px",
			lineHeight: 1,
			letterSpacing: "2px",
			padding: "0 10px",
		},
		rootOperator: {
			height: "40px",
			padding: "0 16px",
		},
		isStub: {
			height: "25px",
			width: "49px",
		},
		linkProviderReviews: {
			width: "30%",
		},
		buttonProviderReviews: {
			margin: 0,
			height: "40px",
			width: "100%",
			fontSize: "12px",
			lineHeight: 1,
			letterSpacing: "2.3px",
		},
	},
	[`@media (max-width: ${theme.media.xs})`]: {
		root: {
			fontSize: "11px",
			whiteSpace: "nowrap",
		},
		rootOperator: {
			fontSize: "12px",
		},
		buttonProviderReviews: {
			fontSize: "12px",
		},
	},
}));

const TagButton = (props) => {
	let {
		ApplicationModel: { text },
		match: { params },
		elem,
		providerButton,
		ratesButton,
		operatorRatesButton,
		operatorBeautifulNumbersButton,
		ratesMobileButton,
		beautifulNumberButton,
		providerInetTvMobileButton,
		providerInetMobileButton,
		anotherUrl,
		operatorStyle,
		stub,
	} = props;
	const classes = useStyles();
	const match = useWithDefaultParams();
	let regionUrl = match?.params?.regionUrl;
	let url = anotherUrl || "/";

	const setMetciks = () => {
		if (elem?.translit === "esim") {
			sendMetriks("OPEN_ESIM");
		}
	};

	if (stub) {
		return <div className={classes.isStub}></div>;
	}

	if (ratesButton) {
		if (!props.elem) {
			url = generateUrl(routes.Rates.route, {
				regionUrl: params.regionUrl,
			});
		} else {
			url = generateUrl(routes.RatesTags.route, {
				regionUrl: params.regionUrl,
				tagCode: elem.url,
			});
		}
	} else if (providerButton) {
		if (!props.elem) {
			url = generateUrl(routes.ProviderRates.route, {
				regionUrl: params.regionUrl,
				providerName: params.providerName,
			});
		} else {
			url = generateUrl(routes.ProviderRatesTags.route, {
				regionUrl: params.regionUrl,
				providerName: params.providerName,
				tagCode: elem.url,
			});
		}
	} else if (operatorRatesButton) {
		if (!props.elem) {
			url = generateUrl(routes.OperatoryTariffs.route, {
				regionUrl: regionUrl,
				operator: params.operator,
			});
		} else {
			url = generateUrl(routes.OperatoryTariffs.route, {
				regionUrl: regionUrl,
				operator: params.operator,
				tagCode: elem.translit,
			});
		}
	} else if (operatorBeautifulNumbersButton) {
		if (!props.elem) {
			url = generateUrl(routes.OperatoryBeautifulNumbers.route, {
				regionUrl: regionUrl,
				operator: params.operator,
			});
		} else {
			url = generateUrl(routes.OperatoryBeautifulNumbers.route, {
				regionUrl: regionUrl,
				operator: params.operator,
				tagCode: elem.translit,
			});
		}
	} else if (ratesMobileButton) {
		if (!props.elem) {
			url = generateUrl(routes.RatesMobile.route, {
				regionUrl: regionUrl,
			});
		} else {
			url = generateUrl(routes.RatesMobile.route, {
				regionUrl: regionUrl,
				tagCode: elem.translit,
			});
		}
	} else if (beautifulNumberButton) {
		if (!props.elem) {
			url = generateUrl(routes.BeautifulNumbers.route, {
				regionUrl: regionUrl,
			});
		} else {
			url = generateUrl(routes.BeautifulNumbers.route, {
				regionUrl: regionUrl,
				tagCode: elem.translit,
			});
		}
	} else if (providerInetTvMobileButton) {
		url = generateUrl(routes.RatesTags.route, {
			regionUrl: params.regionUrl,
			tagCode: "internet-tv-mobile",
		});
	} else if (providerInetMobileButton) {
		url = generateUrl(routes.RatesTags.route, {
			regionUrl: params.regionUrl,
			tagCode: "internet-i-mobilnaya-svyaz",
		});
	}

	return (
		<NavLink
			to={url}
			datatest={props.url}
			exact
			className={classNames("", {
				[classes.linkProviderReviews]: props.isProviderReviews,
			})}
		>
			<div
				className={classNames(classes.root, {
					[classes.rootOperator]: operatorStyle,
					[classes.active]: props.active,
					[classes.unikalnye]: props.unikalnye,
					[classes.buttonProviderReviews]: props.isProviderReviews,
				})}
				onClick={() => setMetciks()}
			>
				{!elem ? text.ALL : elem.name}
				{props.unikalnye ? "🔥" : ""}
			</div>
		</NavLink>
	);
};

export default withRouter(inject("ApplicationModel")(observer(TagButton)));
